module.exports = __webpack_public_path__ + "static/media/A1-28-Ahni_Grav-cod136.ef414b0d.png";